(() => {
  const initializeFloatingProducts = () => {
    document.querySelectorAll('[data-article-floating-product]').forEach((card) => {
      if (card.dataset.initialized === 'true') return;
      card.dataset.initialized = 'true';

      const closeButton = card.querySelector('[data-article-floating-product-close]');
      const storageKey = card.dataset.storageKey;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timeThresholdReached = false;
      let scrollThresholdReached = false;
      let dismissed = false;
      let timerId;

      const readSessionState = () => {
        try {
          const state = window.sessionStorage.getItem(storageKey);
          return state === 'shown' || state === 'dismissed' ? state : null;
        } catch (error) {
          return null;
        }
      };

      const saveSessionState = (state) => {
        try {
          window.sessionStorage.setItem(storageKey, state);
        } catch (error) {
          // sessionStorage can be unavailable in restricted browsing contexts.
        }
      };

      const removeScrollListener = () => {
        window.removeEventListener('scroll', handleScroll);
      };

      const showCard = () => {
        if (dismissed || !timeThresholdReached || !scrollThresholdReached || !card.hidden) return;

        removeScrollListener();
        card.hidden = false;
        saveSessionState('shown');
        window.requestAnimationFrame(() => {
          card.classList.add('is-visible');
        });
      };

      const getScrollProgress = () => {
        const documentHeight = Math.max(
          document.documentElement.scrollHeight,
          document.body ? document.body.scrollHeight : 0
        );
        const scrollableDistance = documentHeight - window.innerHeight;

        if (scrollableDistance <= 0) return 1;
        return Math.min(1, Math.max(0, window.scrollY / scrollableDistance));
      };

      function handleScroll() {
        if (getScrollProgress() < 0.12) return;

        scrollThresholdReached = true;
        removeScrollListener();
        showCard();
      }

      const dismissCard = () => {
        dismissed = true;
        saveSessionState('dismissed');
        removeScrollListener();
        window.clearTimeout(timerId);
        card.classList.remove('is-visible');

        if (reducedMotion.matches) {
          card.hidden = true;
          return;
        }

        window.setTimeout(() => {
          card.hidden = true;
        }, 320);
      };

      const sessionState = readSessionState();
      if (sessionState !== null) return;

      closeButton?.addEventListener('click', dismissCard);
      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();

      timerId = window.setTimeout(() => {
        timeThresholdReached = true;
        showCard();
      }, 7000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFloatingProducts, { once: true });
  } else {
    initializeFloatingProducts();
  }
})();
